import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/provider';
import { queryKeys } from '@/api/queryKeys';
import { STALE_TIMES } from '@/api/queryClient';
import { useNotificationPoller } from './useNotificationPoller';

/**
 * The in-tab notification poller for one mailbox. Renders nothing.
 *
 * The shell mounts one per mailbox it can poll. Each is gated on that
 * mailbox's own saved preference: notifications off means no IMAP work at all,
 * which is the difference between "a feature you turned off" and "a feature
 * that still costs you a round trip a minute".
 */
export function AccountNotificationPoller({
  accountId,
  label,
  isPrimary,
}: {
  accountId: string;
  /** The mailbox as a person knows it: its display name, or its address. */
  label: string;
  isPrimary: boolean;
}): null {
  const api = useApi();
  const prefs = useQuery({
    queryKey: queryKeys.account(accountId).notificationPrefs(),
    queryFn: ({ signal }) => api.push.getPreferences(accountId, signal),
    staleTime: STALE_TIMES.metadata,
  });
  useNotificationPoller({
    accountId,
    enabled: prefs.data?.enabled === true,
    // The primary's title is unchanged; a connected mailbox names itself.
    label: isPrimary ? undefined : label,
  });
  return null;
}
